/**
 * If a cookie doesn't exist set it. If it does exist, update value and set new expiry date
 *
 * @param  {string} label - cookie label
 * @param  {string} value - cookie value
 * @param  {number} expires - expiry time (days).
 *
 * @return {void} No return
 */
import Cookies from "js-cookie";

import deleteCookie from "@brexhq/next/src/utils/deleteCookie";

import { getCookiesDomain } from "./getCookiesDomain";

const updateCookie = (label: string, value: string, expires = 30): void => {
  const savedCookie = Cookies.get(label);
  const domain = getCookiesDomain();

  if (savedCookie !== value) {
    deleteCookie(label);
  }

  Cookies.set(label, value, {
    expires,
    domain,
  });
};

export default updateCookie;
